import { useaxios } from "../../../utils/useaxios";
export default (from, to, barcode, company_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('company_invoice/read.php', { from, to, barcode, company_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setcompanyinvoiceitem', payload: res.data });
            // setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}